module.exports = __webpack_public_path__ + "static/media/dummyImage.137bfb11.svg";